import { render, staticRenderFns } from "./ColorOptionsClipboardButtons.vue?vue&type=template&id=0ed00e0a&scoped=true"
import script from "./ColorOptionsClipboardButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorOptionsClipboardButtons.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ColorOptionsClipboardButtons.vue?vue&type=style&index=0&id=0ed00e0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed00e0a",
  null
  
)

export default component.exports